import styled from 'styled-components'

import { Input } from '@blade/ui-kit'

import type { TypeHelper } from '@blade/std-lib'
import type { InputProps } from '@blade/ui-kit'
import type { ClassNameProps } from '@root/shared/react'

type InputPercentageValues = {
  value: string
  /**
   * From 0 to 1
   */
  percents: number | undefined
}

type InputPercentageProps = {
  value: string
  onChange: (values: InputPercentageValues) => void
  maxPercents?: number
} & ClassNameProps &
  TypeHelper.OmitKey<InputProps, 'value' | 'onChange'>

export const InputPercentage: React.FC<InputPercentageProps> = ({
  value,
  onChange,
  startContent,
  size = 's',
  className,
  maxPercents = 100,
  ...inputProps
}) => (
  <Input
    className={className}
    numeric
    size={size}
    value={value}
    onValueChange={({ floatValue, value }) => {
      onChange({
        value,
        percents: floatValue === undefined ? undefined : floatValue / 100,
      })
    }}
    isAllowed={({ floatValue }) => {
      return floatValue === undefined || floatValue <= maxPercents
    }}
    allowLeadingZeros={false}
    placeholder="0"
    startContent={startContent}
    endContent={<CharIcon>%</CharIcon>}
    {...inputProps}
  />
)

const CharIcon = styled.div`
  color: var(--text-11);
  text-align: right;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
`
